import TsaDialog from './dialog/index.js'
import TsaSignPassword from './signPassword/index'
import TsaSignPasswordV2 from './signPasswordV2/index'
import TsaAgreement from './Agreement/index'
import TsaLoading from './Loading/index'
import TsaSetOrForgetPassword from './setOrForgetPassword/index'
import TsaPersonRealNameInfoVerify from './personRealNameInfoVerify/index'
import TsaCompanyRealNameInfoVerify from './companyRealNameInfoVerify/index'
import TsaHandlerInfoVerify from './handlerInfoVerify/index'
import TsaDigitalCertificateAgreement from './digitalCertificateAgreement/index'
import TsaAuthorizationLetter from './authorizationLetter/index'
import TsaHandlerVerifySuccess from './handlerVerifySuccess/index'
import TsaAuthorizationCode from './authorizationCode/index'
import TsaEnvironmentCheck from './EnvironmentCheck'

export {
    TsaDialog,
    TsaSignPassword,
    TsaSignPasswordV2,
    TsaAgreement,
    TsaLoading,
    TsaSetOrForgetPassword,
    TsaPersonRealNameInfoVerify,
    TsaCompanyRealNameInfoVerify,
    TsaHandlerInfoVerify,
    TsaDigitalCertificateAgreement,
    TsaAuthorizationLetter,
    TsaHandlerVerifySuccess,
    TsaAuthorizationCode,
    TsaEnvironmentCheck

}


// WEBPACK FOOTER //
// ./src/plugins/index.js